<template>
    <div class="appHeader" style="z-index: 100;">
        <div class="left">
            <a v-if="indexPage == true" onclick="window.history.go(-1); return false;" class="headerButton">
                <ion-icon name="chevron-back-outline"></ion-icon>
                {{ title ?? 'بازگشت' }}
            </a>
            <router-link v-else :to="to" class="headerButton">
                <ion-icon name="chevron-back-outline"></ion-icon>
                {{ title ?? 'بازگشت' }}
            </router-link>
        </div>
        <div class="pageTitle">
            <!-- <img width="35" src="assets/img/sabze1.png" alt=""> -->
            ایران ترابر رانندگان
            <!-- <img width="35" src="assets/img/sabze1.png" alt=""> -->
        </div>
        <div class="right">
            <!-- <a v-if="isCargo == true" :href="`sms:?&body=لینک مستقیم اپلیکیشن اعلام بار ایران ترابر http://cargo.iran-tarabar.com`" 
                class="headerButton text-TEAL">
                <ion-icon name="share-social-outline"></ion-icon>
            </a> -->
            <img @click="backTell()" data-bs-toggle="offcanvas" data-bs-target="#actionSheetShare"
                src="../assets/svg/headset-outline.svg" alt="headset" />
            <!-- <a v-on:click="getLocation()" class="headerButton">
        <ion-icon name="location-outline"></ion-icon>
      </a> -->
            <!-- Modal Form -->

            <!-- * Modal Form -->
        </div>
        <div class="offcanvas offcanvas-bottom action-sheet inset" tabindex="-1" id="actionSheetShare">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title">پشتیبانی</h5>
                <a href="#" id="offTell" class="offcanvas-close" style="display: none" data-bs-dismiss="offcanvas">
                    <ion-icon name="close-outline"></ion-icon>
                </a>
            </div>
            <div class="offcanvas-body" v-if="tel">
                <ul class="action-button-list">
                    <li>
                        <a @click="callSupport()" :href="'tel:' + tel" class="btn btn-list">
                            <span>
                                <ion-icon class="text-TEAL" name="call"></ion-icon>
                                تماس
                            </span>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.goftino.com/c/vLBTmK" class="btn btn-list">
                            <span>
                                <ion-icon class="text-TEAL" name="chatbubbles"></ion-icon>
                                گفتگو آنلاین
                            </span>
                        </a>
                    </li>
                    <li>
                        <a href="/support" class="btn btn-list">
                            <span>
                                <ion-icon class="text-TEAL" name="navigate"></ion-icon>
                                ارسال تیکت
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>
<script>
import axios from 'axios';

export default {
    props: ['to', 'indexPage', 'title', 'cargo', 'isCargo'],
    data() {
        return {
            tel: window.localStorage.getItem("tel"),
            axiosConfig: {
                headers: {
                    'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
                    'Accept': 'application/json'
                }
            }
        };
    },
    methods: {
        backTell() {
            if (history.pushState) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?backTell=1';
                window.history.pushState({ path: newurl }, '', newurl);
            }
        },
        callSupport() {
            axios.get("https://core.iran-tarabar.ir/api/driver/support", this.axiosConfig)
                .then((response) => {
                    console.log(response);
                });
        },
    }
}
</script>
<style></style>